module.exports = __webpack_public_path__ + "img/icon-chart.047555d9.svg";